import { COMUNI_TABS_ITEM } from '@/features/comuni/comuni-helper';
import RouteConstants from '@/features/router/RouteConstants';
import { useWhatsappInboxEnabled } from '@/features/whatsappInbox';
import { CampaignIcon } from '@/lib';
import { Card } from '@/lib/Layout/Card';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LuMessageSquare, LuUpload } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

const comuniTabPath = (tab: string) => `${RouteConstants.comuni}?tab=${tab}`;

type HomeAction = {
  titleKey: string;
  descriptionKey: string;
  to: string;
  icon: ReactNode;
  iconClassName: string;
  enabled: boolean;
};

export const ComuniHomeActions: FC = () => {
  const { t } = useTranslation();
  const inboxEnabled = useWhatsappInboxEnabled();
  const actions: HomeAction[] = [
    {
      titleKey: 'home:actionSendTitle',
      descriptionKey: 'home:actionSendDescription',
      to: comuniTabPath(COMUNI_TABS_ITEM.NEW_COMMUNICATION),
      icon: <CampaignIcon className='size-5' />,
      iconClassName: 'bg-brand-50 text-brand-700',
      enabled: true,
    },
    {
      titleKey: 'home:actionUploadTitle',
      descriptionKey: 'home:actionUploadDescription',
      to: comuniTabPath(COMUNI_TABS_ITEM.UPLOADED_LISTS),
      icon: <LuUpload className='size-5' />,
      iconClassName: 'bg-success-100 text-success-700',
      enabled: true,
    },
    {
      titleKey: 'home:actionReplyTitle',
      descriptionKey: 'home:actionReplyDescription',
      to: comuniTabPath(COMUNI_TABS_ITEM.INBOX),
      icon: <LuMessageSquare className='size-5' />,
      iconClassName: 'bg-warning-100 text-warning-700',
      enabled: inboxEnabled,
    },
  ];

  const visibleActions = actions.filter((action) => action.enabled);

  return (
    <div className={twMerge('grid grid-cols-1 gap-4', visibleActions.length > 2 ? 'md:grid-cols-3' : 'md:grid-cols-2')}>
      {visibleActions.map((action) => (
        <Link key={action.titleKey} to={action.to} className='block h-full rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-600'>
          <Card className='h-full flex-col gap-4'>
            <div className={`flex size-12 items-center justify-center rounded-xl ${action.iconClassName}`}>{action.icon}</div>
            <div>
              <h3 className='text-lg font-bold text-quaternary-900'>{t(action.titleKey)}</h3>
              <p className='mt-1.5 text-sm text-quaternary-700'>{t(action.descriptionKey)}</p>
            </div>
            <span className='mt-auto text-sm font-semibold text-brand-700'>{t('home:actionStart')}</span>
          </Card>
        </Link>
      ))}
    </div>
  );
};
